import React, {
  memo,
} from 'react';
import {
  ChargesRowData,
} from 'pages/Dashboard/pages/Billing/types';
import {
  BillingState,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/types/visitNote';
import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ToolTip from 'core/components/Tooltip';
import clsx from 'clsx';
import {
  formatDate,
} from 'utils/date';
import {
  Link,
} from 'react-router-dom';
import NotesIcon from 'core/icons/notes';
import ServiceCell, {
  ClaimInfo,
} from 'pages/Dashboard/pages/Billing/Charges/columns/ServiceCell';

type Props = ChargesRowData & { isExpanded?: boolean };

function _Details(data: Props) {
  const {
    visitDateTime,
    isFinalized,
    reasonForVisit,
    encounterId,
    billingState,
    isChild,
    isExpanded,
    claimCharges,
  } = data;

  const isBillingCompleted = billingState === BillingState.ReviewCompleted;
  const LockIcon = isFinalized ? LockRoundedIcon : LockOpenRoundedIcon;

  return isChild ? (
    <ServiceCell {...data} />
  ) : (
    <div className="flex flex-col gap-2 !truncate max-w-full">
      <div className="flex gap-2  max-w-full items-center truncate">
        <strong className="font-semibold">
          {formatDate(visitDateTime ?? '')}
        </strong>
        <ToolTip title={`Visit Note ${isFinalized ? '' : 'Not '}Finalized`}>
          <LockIcon className="!w-4 !h-4 !text-black" />
        </ToolTip>
        <ToolTip title={`Billing Review ${isBillingCompleted ? 'Completed' : 'Pending'}`}>
          <div>
            <CheckCircleIcon
              className={clsx('!w-4 !h-4', {
                'text-populate-green-1': isBillingCompleted,
                'text-populate-gray-1': !isBillingCompleted,
              })}
            />
          </div>
        </ToolTip>
        <ToolTip
          title={(
            <div className="flex flex-col gap-px">
              <strong className="font-semibold">{reasonForVisit ?? ''}</strong>
              <span className="italic">Open visit note</span>
            </div>
      )}
          placement="top-start"
        >
          <Link
            className="relative truncate"
            to={`/encounters/${encounterId}`}
            onClick={(e) => { e.stopPropagation(); }}
          >
            <div className="flex-1 font-bold truncate gap-1 flex items-center text-blue-500">
              <NotesIcon className="!w-4 !h-4 text-blue-500" />
              <span className="truncate">{reasonForVisit ?? '--'}</span>
            </div>
          </Link>
        </ToolTip>
      </div>
      {!isExpanded && (
        <div className="flex flex-col gap-2">
          {claimCharges?.map((charge) => (
            <ClaimInfo {...charge} key={charge.claimId} />
          ))}
        </div>
      )}
    </div>
  );
}

export default memo(_Details);
